import React from 'react';

export type CenterRendererProps = {
  children?: string;
};

const centerRenderer = (props: CenterRendererProps) => {
  return <span css={{ display: 'block', textAlign: 'center' }}>{props.children}</span>;
};

export default centerRenderer;
